import { Save } from '@mui/icons-material';
import { ComponentProps } from 'react';

import { LoadingButton } from 'src/components/common/buttons/LoadingButton';

export const SaveLoadingButton = (props: ComponentProps<typeof LoadingButton>): JSX.Element => {
    const {
        Icon = Save,
        'aria-label': ariaLabel = 'save changes',
        ...rest
    } = props;

    return (
        <LoadingButton {...rest} aria-label={ariaLabel} Icon={Icon} type="submit" />
    );
};
